import React from "react";
import "./header.css";
import { Link } from "react-router-dom";


const Header = () => {
    return (
        <header className="app__header d-flex flex-item-center">
            <div className="app__header-container app__container">
                <div className="app__header-row">
                    <div className="app__header-top">
                        <h4> Welcome </h4>
                        <h1> What i do isn’t <span> different </span>, How you feel when you work with me is.</h1>
                    </div>
                </div>
                <div className="app__header-row d-flex">
                    <div className="app__header-col -left">
                        <Link to="/about">
                            <span> About Me </span>
                        </Link>
                    </div>

                    <div className="app__header-col -right">
                        <h4> Whoami??? </h4>
                        <p> Hello, My name is <span>Emmanuel Anyigor</span> , I’m a software developer with roughly 3years experience building software architectures and design.</p>
                    </div>
                </div>
            </div>
        </header>
    )
}


export default Header;